<div class="file-manager-wrapper">
  <button type="button" class="cls-btn" (click)="closeDialog()">X</button>
  <h3>Document Upload: {{ totalPrg.currentfilenum }} / {{ totalPrg.totalfilenum }}</h3>
          <div style="position:relative;">
            <p style="color: white;z-index: 1;position:absolute;right:40%;">{{ totalPrg.percentProcessed }} %</p>
            <mat-progress-bar mode="determinate" value="{{totalPrg.percentProcessed}}" style="height:20px;border-radius:5px;"></mat-progress-bar>
          </div>
</div>